import { Sparkles } from 'lucide-react';
import type { ActionProposee, Message } from '../types/assistant.types';
import { CarteAction } from './CarteAction';
import { ListeResultats } from './ListeResultats';

/**
 * La conversation. L'utilisateur à droite, dans une bulle discrète ;
 * l'assistant à gauche, en texte nu précédé de sa marque. Pas de nom,
 * pas d'heure : on sait qui parle et c'est maintenant.
 */
export function Messages({
  messages,
  enAttente,
  onConfirmer,
  onAnnuler,
}: {
  messages: Message[];
  enAttente: boolean;
  onConfirmer: (idMessage: string, action: ActionProposee) => void;
  onAnnuler: (idMessage: string, action: ActionProposee) => void;
}) {
  return (
    <div className="space-y-6">
      {messages.map(message =>
        message.auteur === 'utilisateur' ? (
          <div key={message.id} className="flex justify-end">
            <p className="max-w-xl rounded-2xl bg-neutral-100 px-4 py-2 text-sm text-neutral-900">
              {message.texte}
            </p>
          </div>
        ) : (
          <div key={message.id} className="flex gap-3">
            <span className="bg-brand-100 text-brand-700 mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full">
              <Sparkles className="h-3.5 w-3.5" />
            </span>
            <div className="min-w-0 flex-1">
              <p
                className={`text-sm leading-6 ${
                  message.limite ? 'text-neutral-600' : 'text-neutral-900'
                }`}
              >
                {message.texte}
              </p>
              {message.resultats && (
                <ListeResultats lignes={message.resultats} />
              )}
              {message.action && (
                <CarteAction
                  action={message.action}
                  onConfirmer={() => onConfirmer(message.id, message.action!)}
                  onAnnuler={() => onAnnuler(message.id, message.action!)}
                />
              )}
            </div>
          </div>
        )
      )}
      {enAttente && (
        <div className="flex gap-3" aria-live="polite">
          <span className="bg-brand-100 text-brand-700 mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full">
            <Sparkles className="h-3.5 w-3.5" />
          </span>
          <p className="text-sm text-neutral-400">…</p>
        </div>
      )}
    </div>
  );
}
